import { render, staticRenderFns } from "./StreamingMarkdown.vue?vue&type=template&id=0230372c"
import script from "./StreamingMarkdown.vue?vue&type=script&lang=js"
export * from "./StreamingMarkdown.vue?vue&type=script&lang=js"
import style0 from "./StreamingMarkdown.vue?vue&type=style&index=0&id=0230372c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports